import { math } from 'polished';
import styled, { css, keyframes } from 'styled-components';
import { combineValues, globalTheme } from '@clds/component-theme';
import { iconNextSizeVariant } from '@clds/icon';
import { spinnerVariant } from './theme';
const rotation = keyframes `
   from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
`;
const sizeMixin = css `
  ${combineValues(iconNextSizeVariant(), spinnerVariant(), 
// @ts-expect-error TODO: Fix types
(size, spinner) => math(`${size.width} / ${spinner}`))}
`;
const iconMixin = (props) => {
    var _a;
    // @ts-ignore todo fix after migration
    const size = props.size ? (_a = iconNextSizeVariant()) === null || _a === void 0 ? void 0 : _a(props).width : '100%';
    return css `
    width: ${size};
    height: ${size};
  `;
};
// eslint-disable-next-line import/no-default-export
export default styled.div.attrs((props) => {
    var _a, _b;
    return ({
        size: props.size || 'md',
        // eslint-disable-next-line
        variant: props.variant || 'primary',
        color: combineValues(
        // @ts-ignore TODO fix after DS migration
        (_a = globalTheme.color[props.color]) !== null && _a !== void 0 ? _a : (() => undefined), 
        // @ts-ignore TODO fix after DS migration
        (_b = globalTheme.palette[props.variant]) !== null && _b !== void 0 ? _b : (() => undefined), (color, themeColor) => color || themeColor)(props),
    });
}) `
  ${iconMixin};
  animation: ${rotation} 1s infinite linear;
  border-radius: 100%;

  &:before {
    content: '';
    display: block;
    position: absolute;
    height: 100%;
    width: 100%;
    border-top: ${sizeMixin} solid ${(props) => props.color};
    border-left: ${sizeMixin} solid ${(props) => props.color};
    border-bottom: ${sizeMixin} solid ${(props) => props.color};
    border-right: ${sizeMixin} solid transparent;
    border-radius: 100%;
  }
`;
//# sourceMappingURL=ProgressCircular.js.map